import {
  AppCode,
  AppCodeUse,
  AmbassadorRoute,
  Club,
  Collection,
  CollectionFollower,
  CollectionItem,
  Experience,
  ExperienceGuidePage,
  ExperienceMessage,
  ExperiencePackage,
  Event,
  Favorite,
  Follow,
  Gear,
  Goal,
  GoalParticipant,
  GoalParticipantTrip,
  LiveLog,
  Milestone,
  Photo,
  PointOfInterest,
  PrivacyCode,
  Region,
  RegionItem,
  RideReport,
  Route,
  RouteSetOverview,
  Subscription,
  SegmentMatch,
  TmsJob,
  TmsKey,
  TmsValue,
  Trip,
  User
} from 'data/records'

// These are the records that will be automatically deserialized and stored
// under state.apiv3 when seen All known apiv3 record types should be specified
// here.
export const records = [
  AppCode,
  AppCodeUse,
  AmbassadorRoute,
  Club,
  Collection,
  CollectionFollower,
  CollectionItem,
  Experience,
  ExperienceGuidePage,
  ExperienceMessage,
  ExperiencePackage,
  Event,
  Favorite,
  Follow,
  Gear,
  Goal,
  GoalParticipant,
  GoalParticipantTrip,
  LiveLog,
  Milestone,
  Photo,
  PointOfInterest,
  PrivacyCode,
  Region,
  RegionItem,
  RideReport,
  Route,
  RouteSetOverview,
  Subscription,
  SegmentMatch,
  TmsJob,
  TmsKey,
  TmsValue,
  Trip,
  User
]
